var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJo = function SvgJo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-117.82 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.9 0 0 .9 110.5 0)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-117.82 0H906.182v170.667H-117.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-117.82 170.667H906.182v170.667H-117.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "M-117.82 341.334H906.182V512H-117.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117.82 512l512-256-512-256v512z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.528 288.964l5.664-24.82H4.742l22.93-11.045-15.868-19.9 22.93 11.05 5.664-24.82 5.66 24.82 22.93-11.05-15.865 19.9 22.93 11.044h-25.45l5.662 24.82-15.867-19.92z"
  })))));
};
export default SvgJo;